var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM1.53364 16C1.53364 23.9896 8.01045 30.4664 16 30.4664C23.9896 30.4664 30.4664 23.9896 30.4664 16C30.4664 8.01045 23.9896 1.53364 16 1.53364C8.01045 1.53364 1.53364 8.01045 1.53364 16Z",
    fill: "url(#paint0_linear_3907_193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.616 7C13.1788 7 12.7594 7.17369 12.4503 7.48286C12.1411 7.79203 11.9674 8.21136 11.9674 8.64859C11.9674 9.08583 12.1411 9.50515 12.4503 9.81432C12.7594 10.1235 13.1788 10.2972 13.616 10.2972H17.3842C17.8214 10.2972 18.2408 10.1235 18.5499 9.81432C18.8591 9.50515 19.0328 9.08583 19.0328 8.64859C19.0328 8.21136 18.8591 7.79203 18.5499 7.48286C18.2408 7.17369 17.8214 7 17.3842 7H13.616ZM7.83557 20.3819C7.02729 17.1487 6.62315 15.5331 7.47099 14.446C8.31884 13.3589 9.98627 13.3589 13.3193 13.3589H17.681C21.0139 13.3589 22.6795 13.3589 23.5283 14.446C24.3771 15.5322 23.9729 17.1497 23.1646 20.3819C22.6503 22.4384 22.394 23.4661 21.6272 24.0653C20.8604 24.6635 19.8006 24.6635 17.681 24.6635H13.3193C11.1996 24.6635 10.1398 24.6635 9.373 24.0653C8.60617 23.4661 8.34899 22.4384 7.83557 20.3819Z",
    fill: "url(#paint1_linear_3907_193)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8735 9.35738C18.9792 9.13671 19.0342 8.89523 19.0345 8.65058C19.0348 8.40594 18.9805 8.16431 18.8754 7.94336C19.5189 7.94807 20.021 7.97727 20.4684 8.1525C21.0037 8.36189 21.4693 8.71774 21.8118 9.17933C22.1575 9.64471 22.3205 10.241 22.5438 11.0625L22.5871 11.2226L23.0704 14.0139C22.6851 13.7483 22.1886 13.59 21.5461 13.4958L21.207 11.5298C20.9385 10.55 20.8415 10.242 20.6776 10.0215C20.4931 9.77293 20.2424 9.58129 19.9541 9.46854C19.7468 9.38753 19.4972 9.36492 18.8735 9.35738ZM12.1256 7.94336C12.0206 8.16431 11.9662 8.40594 11.9666 8.65058C11.9669 8.89523 12.0219 9.13671 12.1275 9.35738C11.5039 9.36397 11.2542 9.38753 11.047 9.46854C10.7587 9.58129 10.5079 9.77293 10.3235 10.0215C10.1596 10.242 10.0625 10.55 9.79499 11.5288L9.45491 13.4968C8.81243 13.591 8.31596 13.7483 7.93066 14.013L8.41394 11.2226L8.45727 11.0625C8.68054 10.241 8.84351 9.64471 9.18925 9.17839C9.53203 8.71749 9.99755 8.36231 10.5326 8.15344C10.9801 7.97822 11.4822 7.94901 12.1256 7.9443V7.94336Z",
    fill: "url(#paint2_linear_3907_193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3907_193",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0451A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3907_193",
    x1: 15.5,
    y1: 7,
    x2: 15.5,
    y2: 24.6635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3907_193",
    x1: 15.5005,
    y1: 7.94336,
    x2: 15.5005,
    y2: 14.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0451A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.14e4ad23add9c408d85cb93ece1c31a4.svg";
export { ForwardRef as ReactComponent };